import { UserLogin, VerifyCode, GetDashboard } from "./actions/APIcalls";
import Cookies from "js-cookie";

class Auth {
    constructor() {
        this.authenticated = false;
        this.user = { name: "درحال بارگیری" }
    }

    setLogin(user, expired, disconnected) {
        // console.log("set Log",user, expired, downGradeWarning);
        let temp = (expired === "true" ? true : false)
        this.authenticated = true;
        this.user = {
            ...user,
            expiredAccount: temp,
            disconnected: { ...disconnected }
        }
    }

    setLogout(user) {
        this.authenticated = false;
        this.user = user;
    }

    login(params, showError, setLoading) {
        const response = UserLogin(params);
        response.then(async (response) => {
            if (typeof response != 'undefined') {
                if (response.data.success) {
                    this.authenticated = true;
                    if (params.rememberMe) {
                        Cookies.set("token", response.data.token, { expires: 30 });
                    } else {
                        Cookies.set("token", response.data.token);
                    }
                    let res = await GetDashboard()
                    if (res.data.channel) {
                        window.location.href = '/';
                    } else {
                        window.location.href = '/channels';
                    }
                } else {
                    showError({ show: true, text: response.data.error })
                }
            } else {
                showError({ show: true, text: 'ورود با اختلال مواجه شد ' })
            }
            setLoading(false)
        });
    }

    register(params, showError, setLoading) {
        const response = VerifyCode(params);
        response.then((response) => {
            if (response.data.success) {
                this.authenticated = true;
                Cookies.set("token", response.data.token);
                window.location.href = '/';
            } else {
                showError({ show: true, text: response.data.error })
            }
            setLoading(false)
        });
    }

    logout() {
        this.authenticated = false;
        Cookies.remove("token");
        window.location.href = '/signin/main';
    }

    getUser() {
        return this.user;
    }

    isAuthenticated() {
        return this.authenticated;
    }
}

export default new Auth();